export const UserRoles = {
  ATTORNEY: 'ATTORNEY',
  FIRM_ADMIN: 'FIRM_ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
} as const;

export const UserRoleTitles = {
  [UserRoles.ATTORNEY]: 'Attorney',
  [UserRoles.FIRM_ADMIN]: 'Firm Admin',
  [UserRoles.SUPER_ADMIN]: 'Super Admin',
} as const;

export const employeeRoleList = [UserRoles.ATTORNEY] as const;

export const adminRoleList = [
  UserRoles.FIRM_ADMIN,
  UserRoles.SUPER_ADMIN,
] as const;

export const userRoleList = [...employeeRoleList, ...adminRoleList] as const;
